import { defineComponent } from '@vue/runtime-dom'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'

export default defineComponent({
  name: 'groupbuttonocurrence',
  mixins: [ AccountMixin, CompanyMixin, PermissionMixin ],
  data () {
    return {
      isActive: false,
      hoverIcon: false,
      isKanban: false,
      roles: Roles
    }
  },
  computed: {
    getIconSrc () {
      return this.isActive
        ? '../../../../../../../static/img/realestate/icone_kanban_branco.svg'
        : (this.hoverIcon
          ? '../../../../../../../static/img/realestate/icone_kanban_branco.svg'
          : '../../../../../../../static/img/realestate/icone_kanban_verde.svg')
    }
  },
  methods: {
    changeOptions (e) {
      document.getElementById(e).className = 'btn btn-active'
      this.$emit('changeKanban', e.includes('kanban'))
      if (e === 'kanban') {
        document.getElementById('table').className = 'btn'
        this.isKanban = true
      }
      if (e === 'table') {
        document.getElementById('kanban').className = 'btn'
        this.isKanban = false
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/groupbuttonocurrence/groupbuttonocurrence.js